import { render, staticRenderFns } from "./Sched_esterno.vue?vue&type=template&id=21fdb2f3&scoped=true&"
import script from "./Sched_esterno.vue?vue&type=script&lang=js&"
export * from "./Sched_esterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fdb2f3",
  null
  
)

export default component.exports